import type { ShellApi } from '../../core/models'

export function getShellApiInstance(): ShellApi {
  try {
    return (window.opener.shell as ShellApi) || globalThis.shell
  } catch {
    return globalThis.shell
  }
}
